// Whether the overlay drawer is showing an artifact right now (#12452).
//
// The drawer owns its artifact pane as local state; Layout, which decides at
// event time where a document opens, has to know about it. While the drawer
// shows an artifact, a document or citation opened from anywhere goes to the
// drawer, whatever the surface's document mode: opened in the split pane, it
// would sit behind the drawer's backdrop where nobody can see it.
import { create } from "zustand";

import { getViewerMode } from "../FpPages/viewerMode";

interface DrawerArtifactState {
  showing: boolean;
  /** Whether the drawer is open at all, whatever it shows. Layout counts an
   *  open drawer as an open viewer, so the sidebar it collapsed stays
   *  collapsed when the viewer moves between the pane and the drawer. */
  open: boolean;
}

/**
 * Page-scoped by design: the drawer is mounted once, next to the routed
 * Layout, and both read this at event time. A store rather than a module
 * `let` so the story harness resets it between stories.
 */
export const useDrawerArtifactStore = create<DrawerArtifactState>()(() => ({
  showing: false,
  open: false,
}));

/** Whether a document, note, citation or record preview opened now belongs
 *  to the overlay drawer: the surface is in overlay mode, or the drawer is
 *  showing an artifact the open would otherwise land behind. Read at event
 *  time from the live pathname. */
export const opensInDrawer = (pathname: string): boolean =>
  getViewerMode(pathname) === "overlay" ||
  useDrawerArtifactStore.getState().showing;
